import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import type { PageViewSourceState } from '@/shared/lib/pageViewSource';

import { useBalanceStore } from '@/entities/balance';
import { peekPendingRecordingRedirect } from '@/entities/recording';
import { useGetSpaces } from '@/entities/teamspace/model/useGetSpaces';

import { PATHS } from '@/shared/constants/routes/paths';
import { Loader } from '@/shared/ui/Loader';

const DEFAULT_TAB_SOURCE_STATE: PageViewSourceState = { source: 'default_tab' };

export const HomeRedirect = () => {
  const navigate = useNavigate();
  const { data: spaces, isLoading } = useGetSpaces(true);
  const hasTrialPlan = useBalanceStore((state) => state.hasTrialPlan);
  const isBalanceLoaded = useBalanceStore((state) => state.isBalanceLoaded);

  useEffect(() => {
    if (!isLoading && spaces?.length) {
      const spaceForRedirect = spaces[0];
      const pendingRecordId = peekPendingRecordingRedirect();

      if (pendingRecordId) {
        navigate(`/${PATHS.spaces}/${spaceForRedirect.id}/${PATHS.records}/${pendingRecordId}`, { replace: true });
        return;
      }

      if (!isBalanceLoaded) return;

      if (hasTrialPlan) {
        navigate(`/${PATHS.spaces}/${spaceForRedirect.id}/${PATHS.translation}`, {
          replace: true,
          state: DEFAULT_TAB_SOURCE_STATE,
        });
        return;
      }

      navigate(`/${PATHS.spaces}/${spaceForRedirect.id}`, { replace: true });
    }
  }, [spaces, isLoading, navigate, isBalanceLoaded, hasTrialPlan]);

  return <Loader />;
};
